import { createFileRoute, redirect } from '@tanstack/react-router'
import Loader from '@/components/common/Loader'
import { lazy, Suspense } from 'react'
import {
  dashboardActivitiesQueryOptions,
  dashboardCountsQueryOptions,
  dashboardDeadlinesQueryOptions,
  dashboardProjectsQueryOptions,
} from '@/features/city-clerk/city-clerk-dashboard/query-options'
import { PLACEHOLDER_IDS } from '@/components/layout/sidebar/constants'

const ClerkDashboard = lazy(async () => {
  const module = await import(
    '@/features/city-clerk/city-clerk-dashboard/pages/ClerkDashboard/ClerkDashboard'
  )
  return { default: module.default }
})

export const Route = createFileRoute('/(app)/city-clerk/$id/dashboard')({
  beforeLoad: ({ context }) => {
    if (context.auth.loading) return
    if (!context.auth.userInfo?.uiCapabilities?.dashboardView) {
      throw redirect({ to: '/access-denied' })
    }
  },
  loader: ({ context: { queryClient }, params: { id } }) => {
    if (!id || id === PLACEHOLDER_IDS.NO_CITY_CLERK) return
    return Promise.all([
      queryClient.fetchQuery(dashboardCountsQueryOptions(id)),
      queryClient.fetchQuery(dashboardProjectsQueryOptions(id)),
      queryClient.fetchQuery(dashboardDeadlinesQueryOptions(id)),
      queryClient.fetchQuery(dashboardActivitiesQueryOptions(id)),
    ])
  },
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <Suspense
      fallback={
        <div className="h-page bg-(--color-surface) flex items-center justify-center z-9999">
          <Loader size="lg" />
        </div>
      }
    >
      <ClerkDashboard />
    </Suspense>
  )
}
